import React, { useState } from "react";
import "./style.scss";
import RevealAnimation from "../RevealAnimation";
import Button from "../Button";
import RightArrow from "./../../assets/Images/services/massage-chat.png";
import { Link } from "gatsby";
import { Tooltip } from "@material-ui/core";

function OurOfferingLists({
  listTitle = "",
  CardListData = [],
  pageName = "consult",
  sectionTitle = "",
  hideCTA = false,
}) {
  return (
    <>
      {sectionTitle && (
        <RevealAnimation
          component={"h2"}
          animation={"slide-left"}
          className="title-header mt-15 title-underline"
        >
          {sectionTitle}
        </RevealAnimation>
      )}
      {listTitle && (
        <div className="offer-content">
          <p className="offer-details-heading" style={{ fontWeight: "bold" }}>
            {listTitle}
          </p>
        </div>
      )}
      <div className={`offer-list-items ${listTitle ? "" : "mt-70"}`}>
        <div className="expertise-items list-offer-card-items body-container">
          {CardListData?.map((item, idx) => (
            <div key={idx} className="card-item-wrapper">
              <div className="card-img-wrapper">
                {item?.image?.type === "icon" ? (
                  <item.image.component {...item.image.props} />
                ) : (
                  <img
                    {...item.image.props}
                    alt={item.label}
                    src={item.image}
                  />
                )}
              </div>
              <div className="card-content-wrapper">
                <div className="card-content-body">
                  <h2>{item?.label}</h2>
                  <p>{item?.details}</p>
                </div>
                <div className="card-content-btns">
                  {!hideCTA && (
                    <div className="card-control-btnLink">
                      <Link
                        target="_self"
                        to={`/contact-us?type=${encodeURIComponent(
                          pageName
                        )}&name=${encodeURIComponent(item?.label)}`}
                      >
                        <Tooltip title={item?.buttonName} placement="bottom">
                          <Button
                            customClassName="service-offering-btn"
                            color="primary"
                            variant="text"
                            onClick={(e) => e.stopPropagation()}
                            label={"Ask an Expert"}
                            tip={item?.buttonName}
                            tooltip="no"
                          />
                        </Tooltip>
                      </Link>
                    </div>
                  )}

                  {item?.path && (
                    <div className="card-control-btnLink">
                      <Link target="_self" to={item?.path}>
                        <Tooltip title={item?.buttonName} placement="bottom">
                          <Button
                            customClassName="service-offering-btn-secondary"
                            color="primary"
                            variant="text"
                            onClick={(e) => e.stopPropagation()}
                            label={"View Details"}
                            tip={item?.buttonName}
                            tooltip="no"
                          />
                        </Tooltip>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default OurOfferingLists;
